import { useState } from 'react';
import client from '../api/client';
import FraseAlexa, { SceltaAlexa, aggiornaFrasi, useParla } from '../components/FraseAlexa';
import { messaggioErrore } from '../utils/apiError';

const bottone = 'px-3 py-2 rounded-lg border text-sm bg-surface';

// Parla con Alexa (03/10/2026: «anche per frasi al volo»): si compone la frase a pezzi e si fa dire adesso,
// su una Alexa o su tutte. La stessa frase, scritta, funziona da WhatsApp con la regola @alexa. Le frasi salvate
// (04/10/2026) si dicono con un tocco, si usano nelle regole e da WhatsApp con «(frase nome)».
export default function AlexaPage() {
  const dati = useParla();
  const [voce, setVoce] = useState('');
  const [frase, setFrase] = useState('');
  const [modifica, setModifica] = useState(null); // la frase salvata che si sta cambiando
  const [esito, setEsito] = useState('');
  const [errore, setErrore] = useState('');
  const [inCorso, setInCorso] = useState(false);

  const di = async testo => {
    if (!window.confirm('Alexa parlerà davvero in casa. La faccio parlare?')) return;
    setEsito(''); setErrore(''); setInCorso(true);
    try {
      const { data } = await client.post('/v1/home-assistant/parla/', { voce, frase: testo });
      setEsito(data.text);
    } catch (e) { setErrore(messaggioErrore(e, 'Alexa non ha parlato.')); }
    finally { setInCorso(false); }
  };
  const salvaModifica = async () => {
    setErrore('');
    try {
      const { data } = await client.patch(`/v1/home-assistant/frasi/${modifica.id}/`, { frase });
      aggiornaFrasi(data); setEsito(`«${modifica.nome}» aggiornata, anche nelle regole che la usano.`);
      setModifica(null); setFrase('');
    } catch (e) { setErrore(messaggioErrore(e, 'Frase non aggiornata.')); }
  };
  const elimina = async f => {
    if (!window.confirm(`Eliminare la frase «${f.nome}»?`)) return;
    setErrore('');
    try {
      const { data } = await client.delete(`/v1/home-assistant/frasi/${f.id}/`);
      aggiornaFrasi(data);
    } catch (e) { setErrore(messaggioErrore(e, 'Frase non eliminata.')); }
  };

  const frasi = dati?.frasi || [];
  return <div className="max-w-2xl mx-auto space-y-5">
    <header>
      <h1 className="text-2xl font-semibold">Parla con Alexa</h1>
      <p className="text-sm text-muted mt-1">Componi una frase con voci, toni, pause, suoni ed esclamazioni e falla dire
        adesso. Tocca un pezzo per cambiarlo o spostarlo.</p>
    </header>
    {dati?.errore && <p role="alert" className="p-3 border rounded-lg bg-warning-bg text-warning">
      Non riesco a leggere le Alexa: Home Assistant è collegato nei Servizi?</p>}
    <SceltaAlexa voci={dati?.voci} valore={voce} onChange={setVoce} />

    {frasi.length > 0 && <section className="space-y-2" aria-label="Frasi salvate">
      <h2 className="font-medium">Frasi salvate</h2>
      <ul className="space-y-2">
        {frasi.map(f => <li key={f.id} className={`rounded-lg border p-3 ${modifica?.id === f.id ? 'border-brand-600' : ''}`}>
          <div className="flex flex-wrap items-center gap-2">
            <strong className="text-sm text-ink flex-1 min-w-0">{f.nome}</strong>
            <button type="button" className={bottone} disabled={inCorso} onClick={() => di(f.frase)}
              aria-label={`Di’ adesso ${f.nome}`}>🔊 Di’</button>
            <button type="button" className={bottone} aria-label={`Modifica ${f.nome}`}
              onClick={() => { setModifica(f); setFrase(f.frase); setEsito(''); }}>✎</button>
            <button type="button" className={bottone} aria-label={`Elimina ${f.nome}`} onClick={() => elimina(f)}>🗑</button>
          </div>
          <p className="mt-1 text-xs text-muted break-words">{f.frase}</p>
        </li>)}
      </ul>
    </section>}

    <FraseAlexa valore={frase} onChange={valore => { setEsito(''); setFrase(valore); }} prova={false} salva={!modifica}
      etichetta={modifica ? `Modifica «${modifica.nome}»` : 'Frase'} />
    {modifica
      ? <div className="flex gap-2">
        <button type="button" className="flex-1 rounded-lg px-4 py-3 bg-brand-600 text-white hover:bg-brand-700 font-medium disabled:opacity-50"
          disabled={!frase.trim()} onClick={salvaModifica}>Salva le modifiche</button>
        <button type="button" className={bottone} onClick={() => { setModifica(null); setFrase(''); }}>Annulla</button>
      </div>
      : <button type="button" className="w-full rounded-lg px-4 py-3 bg-brand-600 text-white hover:bg-brand-700 font-medium disabled:opacity-50"
        disabled={!frase.trim() || inCorso} onClick={() => di(frase)}>{inCorso ? 'Alexa parla…' : '🔊 Di’ adesso'}</button>}
    {esito && <p role="status" className="text-sm">{esito}</p>}
    {errore && <p role="alert" className="text-sm text-warning">{errore}</p>}
    <section className="rounded-lg border p-3 text-sm space-y-1">
      <p className="font-medium">Da WhatsApp</p>
      <p className="text-muted">Con la regola @alexa scrivi la stessa frase nella chat con te stesso, per esempio:</p>
      <p className="rounded bg-surface-2 px-3 py-2 break-words">@alexa (su giorgio) (sussurra) buonanotte (pausa) (normale) sogni d&apos;oro! (magia)</p>
      <p className="text-muted">«(su …)» sceglie l&apos;Alexa; senza, parlano tutte. Una frase salvata si richiama per nome:
        «@alexa (frase A tavola)». La frase scritta qui sopra si copia da «Scrivila a mano».</p>
    </section>
  </div>;
}
